/**
 * Utility functions for date formatting in different languages
 */

// Month names in Polish
const POLISH_MONTHS = [
  'Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec',
  'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'
];

// Month abbreviations in English
const ENGLISH_MONTHS = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

/**
 * Formats a date string (YYYY-MM-DD) into a localized date word
 * @param dateString - Date in format YYYY-MM-DD
 * @param language - Language code ('en' or 'pl')
 * @returns Formatted date word (e.g., "May, 2023" or "Maj, 2023")
 */
export const formatDateWord = (dateString: string, language: string): string => {
  try {
    const [year, month] = dateString.split('-');
    const monthIndex = parseInt(month, 10) - 1; // Convert to 0-based index
    
    if (isNaN(monthIndex) || monthIndex < 0 || monthIndex > 11) {
      throw new Error(`Invalid month: ${month}`);
    }
    
    if (language === 'pl') {
      return `${POLISH_MONTHS[monthIndex]}, ${year}`;
    } else {
      return `${ENGLISH_MONTHS[monthIndex]}, ${year}`;
    }
  } catch (error) {
    console.error('Error formatting date word:', error);
    return dateString; // Return original date string as fallback
  }
};